__turbopack_context__.v({
  "block": "Y4xrMW_block",
  "decision": "Y4xrMW_decision",
  "decisionTitle": "Y4xrMW_decisionTitle",
  "decisions": "Y4xrMW_decisions",
  "evidence": "Y4xrMW_evidence",
  "eyebrow": "Y4xrMW_eyebrow",
  "grid": "Y4xrMW_grid",
  "label": "Y4xrMW_label",
  "list": "Y4xrMW_list",
  "listItem": "Y4xrMW_listItem",
  "outcome": "Y4xrMW_outcome",
  "root": "Y4xrMW_root",
  "source": "Y4xrMW_source",
});
